import appConstants from "../../../../../../appConstants";
import { MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';

class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.DriverPreferences,
      keyColumn: "startTime",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Start Time",
          field: "startTime",
          headerTooltip: "Start Time",
          minWidth: appConstants.columnWidth.W_110,
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.TIME,
          },
        },
        {
          headerName: "Default Driver Count",
          field: "defaultDriverCount",
          headerTooltip: "Driver Count",
          minWidth: appConstants.columnWidth.W_170,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Monday",
          field: "mondayDriverCount",
          headerTooltip: "Monday Driver Count",
          minWidth: appConstants.columnWidth.W_90,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Tuesday",
          field: "tuesdayDriverCount",
          headerTooltip: "Tuesday Driver Count",
          minWidth: appConstants.columnWidth.W_90,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Wednesday",
          field: "wednesdayDriverCount",
          headerTooltip: "Wednesday Driver Count",
          minWidth: appConstants.columnWidth.W_120,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Thursday",
          field: "thursdayDriverCount",
          headerTooltip: "Thursday Driver Count",
          minWidth: appConstants.columnWidth.W_120,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Friday",
          field: "fridayDriverCount",
          headerTooltip: "Friday Driver Count",
          minWidth: appConstants.columnWidth.W_90,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Saturday",
          field: "saturdayDriverCount",
          headerTooltip: "Saturday Driver Count",
          minWidth: appConstants.columnWidth.W_90,
          filter: MultiSelectFilter,
        },
         {
          headerName: "Sunday",
          field: "sundayDriverCount",
          headerTooltip: "Sunday Driver Count",
          minWidth: appConstants.columnWidth.W_90,
          filter: MultiSelectFilter,
        },
      ],
    };
  }
}

export default GridConfig;
